var _defs, _polyline, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.33,
    height: 92,
    viewBox: "0 0 87.33 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "26.64 81.73 8.37 9.09 80.62 29.37"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.59,
    y1: 50.51,
    x2: 40.15,
    y2: 68.68
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.61,
    y1: 55.62,
    x2: 35.59,
    y2: 50.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.15,
    y1: 68.68,
    x2: 53.61,
    y2: 55.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 40.15,
    y1: 68.68,
    x2: 22.13,
    y2: 63.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "22.13 63.58 26.69 81.76 40.15 68.68"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 22.13,
    y1: 63.58,
    x2: 35.59,
    y2: 50.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.59,
    y1: 50.51,
    x2: 49.06,
    y2: 37.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.06,
    y1: 37.44,
    x2: 62.52,
    y2: 24.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.5,
    y1: 19.27,
    x2: 49.06,
    y2: 37.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.06,
    y1: 37.44,
    x2: 31.03,
    y2: 32.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.03,
    y1: 32.34,
    x2: 35.59,
    y2: 50.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 35.59,
    y1: 50.51,
    x2: 17.56,
    y2: 45.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.56,
    y1: 45.41,
    x2: 22.13,
    y2: 63.58
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 27.24,
    x2: 17.56,
    y2: 45.41
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.03,
    y1: 32.34,
    x2: 13,
    y2: 27.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.56,
    y1: 45.41,
    x2: 31.03,
    y2: 32.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 31.03,
    y1: 32.33,
    x2: 44.5,
    y2: 19.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 44.5,
    y1: 19.27,
    x2: 26.46,
    y2: 14.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 26.46,
    y1: 14.16,
    x2: 31.03,
    y2: 32.33
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "13 27.24 8.44 9.06 26.46 14.16"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13,
    y1: 27.24,
    x2: 26.46,
    y2: 14.16
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "67.09 42.54 80.55 29.48 62.52 24.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.52,
    y1: 24.37,
    x2: 67.09,
    y2: 42.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 67.09,
    y1: 42.54,
    x2: 49.06,
    y2: 37.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 49.06,
    y1: 37.44,
    x2: 53.61,
    y2: 55.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 53.61,
    y1: 55.62,
    x2: 67.09,
    y2: 42.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 62.52,
    y1: 24.37,
    x2: 44.5,
    y2: 19.27
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/Threejs.003c73b47edb88b9a7824e063a43b5ce.svg";
export { ForwardRef as ReactComponent };